import People from './Model/people';
import SuperProperty from './Model/superProperty';
import { setSuperProperty, setPeopleProperty, identifyUser } from './mixpanelClient';

export const setMixpanelSuperProperties = (user, eventId) => {
  if (user) {
    const mixpanelSuperProperty = new SuperProperty()
      .setUserKey(user.userKey)
      .setUserName(user.firstName, user.lastName)
      .setUserEmail(user.email)
      .setEventKey(eventId)
      .build();
    setSuperProperty(mixpanelSuperProperty);
  }
};

export const setMixpanelPeopleProperty = (user, eventRegistrationId) => {
  const mixpanelPeopleProperty = new People()
    .setUserKey(user.userKey)
    .setUserName(user.firstName + ' ' + user.lastName)
    .setUserEmailDomain(user.email)
    .setUserEventRegistrationId(eventRegistrationId)
    .build();
  setPeopleProperty(mixpanelPeopleProperty);
};

export const setMixpanelUserIdentity = (userId) => {
  identifyUser(userId);
};

const setMixPanelProperties = (user, eventID, eventRegistrationId) => {
  setMixpanelSuperProperties(user, eventID);
  setMixpanelPeopleProperty(user, eventRegistrationId);
  setMixpanelUserIdentity(user.userKey);
};

export default setMixPanelProperties;
